export default __webpack_public_path__ + "assets/img/avatar-5.0fbdcc9.png";